// import 'babel-polyfill';

import Vue from 'vue';
// import Vue from "vue/dist/vue.js";

import VueI18n from 'vue-i18n';
// import App from "./App.vue";

// import root App component
import router from '@/router/';
import store from '@/store/';
import en from '@/lang/en.json';
import 'bootstrap';
import components from '@/components/';
import _ from 'lodash';
import moment from 'moment';
import config from '@/config';
import FlagIcon from 'vue-flag-icon';
import AsyncComputed from 'vue-async-computed';
import { mapState, mapGetters } from 'vuex';
import VueSweetalert2 from 'vue-sweetalert2';
import VTooltip from 'v-tooltip';
import VueInputAutowidth from 'vue-input-autowidth';
import vSelect from 'vue-select';
import $ from 'jquery';

require('./utils/scroll-tag.js');
require('./utils/loading-button.js');
require('./styles/main.scss');
// required by Bootstrap

import 'vue-select/dist/vue-select.css';

const messages = {
  en
};

Vue.use(VTooltip);
Vue.use(AsyncComputed);
Vue.use(VueSweetalert2);
Vue.use(VueInputAutowidth);
Vue.component('v-select', vSelect);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: config.locale,
  messages
});

Vue.use(FlagIcon);

Vue.mixin({
  computed: {
    ...mapState(['staff', 'currentOrganization']),
    ...mapGetters(['isWhiteLabel'])
  },
  methods: {
    can(ability) {
      if (!this.$store.state.staff) {
        return false;
      }
      return _.includes(this.$store.state.staff.user_group.scopes.split(' '), ability);
    },
    async confirmModal(event, title, text, callable, ...args) {
      let result = await this.$swal({
        title: title,
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('confirm_yes'),
        cancelButtonText: this.$t('confirm_no'),
        confirmButtonClass: 'btn btn-success btn-lg mr-2',
        cancelButtonClass: 'btn btn-lg ',
        buttonsStyling: false
      });

      if (result.value) {
        callable.call(event, ...args);
      } else if (result.dismiss === this.$swal.DismissReason.cancel) {
        this.$swal.noop();
      }
    }
  },
  store
});

Vue.filter('t', function (str, ...args) {
  // Workaround to use { and } in templates
  return i18n
    .t(str, args)
    .replace(/&#123;/g, '{')
    .replace(/&#125;/g, '}');
});

Vue.filter('lowercase', function (str) {
  return str.toLowerCase();
});

Vue.filter('empty', function (o) {
  return _.isEmpty(o);
});

Vue.filter('nl2br', function (str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
});

Vue.filter('titlecase', function (str) {
  return _.upperFirst(str);
});

Vue.filter('datetime', function (value, format) {
  if (value) {
    return moment(String(value)).format(format ? format : 'YYYY-MM-DD hh:mm');
  }
});

Vue.filter('date', function (value, format) {
  if (value) {
    return moment(String(value)).format(format ? format : 'YYYY-MM-DD');
  }
});

Vue.filter('asset', function (path) {
  return config.asset_url + path;
});

Vue.filter('currency', function (str) {
  if (i18n.locale == 'da') {
    var d = ',';
    var t = '.';
  } else {
    var d = '.';
    var t = ',';
  }

  var c = 2;
  var n = parseFloat(str),
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? '.' : d,
    t = t == undefined ? ',' : t,
    s = n < 0 ? '-' : '',
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
});

Vue.prototype.handleErrors = function (errors) {
  console.log('handle errors!!', errors);
};

Object.entries(components).forEach(function (arr) {
  let name = arr[0];
  let component = arr[1];
  Vue.component(name, component);
});

// Init main Vue instance
new Vue({
  el: '#app',
  router,
  store,
  i18n
  // render: (h) => h(App),
}).$mount('#app'); // Mount router to the app

store.dispatch('loadToken');

/*
{ to:
 {
     name: 'mail_builder_edit',
     mail_builder_global_template_id: this.mail_builder_global_template_id
 },
    text: this.mail_builder_global_template.name}
 */
Vue.mixin({
  methods: {
    /**
     * @param breadcrumbs {Array<{ to: { name: String}, text: String }>}
     */
    setBreadcrumbs(breadcrumbs) {
      this.$store.commit('setBreadcrumbs', breadcrumbs);
    },
    async spin(event, callable, ...args) {
      if (event.target) {
        $(event.target).loading();
      }

      try {
        await callable.call(callable, ...args);
      } catch (e) {
        if (event.target) {
          $(event.target).loading(false);
        }

        throw e;
      }

      if (event.target) {
        $(event.target).loading(false);
      }
    }
  }
});
